/**
 * Utility function to completely clear all authentication and user type data from localStorage
 * @param {boolean} preserveUserType - Whether to preserve the userType in localStorage
 */
export const clearAllAuthData = (preserveUserType = false) => {
  // Temporarily store userType if needed
  let userType = null;
  if (preserveUserType) {
    userType = localStorage.getItem('userType');
  }
  
  // List all keys that need to be removed
  const keysToRemove = [
    'token',
    'userRole',
    'isAuthenticated',
    'userData',
    'simulatedUserType',
    'sidebarIsOpen'
  ];
  
  // Add userType to keys to remove if we're not preserving it
  if (!preserveUserType) {
    keysToRemove.push('userType');
  }
  
  // Remove each key
  keysToRemove.forEach(key => {
    if (localStorage.getItem(key) !== null) {
      localStorage.removeItem(key);
    }
  });
  
  // Restore userType if needed
  if (preserveUserType && userType) {
    localStorage.setItem('userType', userType);
  }
};
